import { useState } from "react";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import "../../assets/css/components.css";
import { DateTimePicker } from "../../components/dateTimePicker";

export const MaintenanceDuration = ({
  onChange = () => {},
  initialStartDateValue = new Date(),
  initialEndDateValue = new Date(),
}) => {
  const [startDateTime, setStartDateTime] = useState(
    moment(initialStartDateValue)
  );
  const [endDateTime, setEndDateTime] = useState(moment(initialEndDateValue));
  const handleStartChange = (dateTime) => {
    if (moment.isMoment(dateTime)) {
      setStartDateTime(dateTime);
      onChange({
        start: dateTime.toDate(),
        end: endDateTime ? endDateTime.toDate() : undefined,
      });
    }
  };
  const handleEndChange = (dateTime) => {
    if (moment.isMoment(dateTime)) {
      setEndDateTime(dateTime);
      onChange({
        start: startDateTime ? startDateTime.toDate() : undefined,
        end: dateTime.toDate(),
      });
    }
  };
  const isValidEndDate = (current) => {
    return current.isAfter(startDateTime);
  };

  return (
    <div className="grey-container">
      <label>Maintenance</label>
      <hr />
      <DateTimePicker
        value={startDateTime}
        onChange={handleStartChange}
        name="startDateTime"
        placeholder="Start Date & Time"
      />
      <DateTimePicker
        value={endDateTime}
        onChange={handleEndChange}
        name="endDateTime"
        isValidDate={isValidEndDate}
        placeholder="End Date & Time"
      />
    </div>
  );
};
